module.exports = __webpack_public_path__ + "media/packs/images/flags/TM-aa3a04d22805a0305b578213b7cefc7b.png";